<template>
  <transition name="bounce">
    <div class="wl-notice" v-if="visible" @click.self="close">
      <div class="bg"></div>
      <div class="notice" :class="{ mobile: isMobile }">
        <div class="title">{{ noticeTitle }}</div>
        <div class="content" v-html="noticeContent"></div>
        <div class="but" @click="close">{{ $t("notice.confirm") }}</div>
      </div>
    </div>
  </transition>
</template>

<script>
/** 将北京时间字符串转为时间戳（UTC+8，格式：YYYY-MM-DD HH:mm:ss） */
function parseBeijingTime(str) {
  const m = String(str).trim().match(
    /^(\d{4})-(\d{2})-(\d{2})\s+(\d{2}):(\d{2})(?::(\d{2}))?$/
  );
  if (!m) return 0;
  const y = +m[1];
  const mo = +m[2] - 1;
  const d = +m[3];
  const h = +m[4];
  const mi = +m[5];
  const s = +(m[6] || 0);
  return Date.UTC(y, mo, d, h - 8, mi, s);
}

/** 按北京时间日程选取当前应展示的公告 id（后生效的覆盖先生效的） */
function getActiveNoticeId(cfg) {
  const items = (cfg.items || [])
    .slice()
    .sort(
      (a, b) => parseBeijingTime(a.startAt) - parseBeijingTime(b.startAt)
    );
  const now = Date.now();
  let activeId = null;
  for (const item of items) {
    if (item.id && now >= parseBeijingTime(item.startAt)) {
      activeId = item.id;
    }
  }
  return activeId;
}

export default {
  name: "WlNotice",
  data() {
    return {
      visible: false,
      noticeKey: "",
    };
  },
  computed: {
    isMobile() {
      return typeof screen !== "undefined" && screen.width < 700;
    },
    noticeTitle() {
      if (!this.noticeKey) return "";
      const key = `notice.${this.noticeKey}.title`;
      const t = this.$t(key);
      return t === key ? "" : t;
    },
    noticeContent() {
      if (!this.noticeKey) return "";
      const key = `notice.${this.noticeKey}.content`;
      const t = this.$t(key);
      return t === key ? "" : t;
    },
  },
  methods: {
    tryOpen() {
      const cfg = window.wl && window.wl.announcement;
      if (!cfg || !cfg.enabled) {
        return;
      }
      const activeId = getActiveNoticeId(cfg);
      if (!activeId) {
        return;
      }
      this.noticeKey = activeId;
      if (!this.noticeTitle && !this.noticeContent) {
        return;
      }
      this.visible = true;
    },
    close() {
      this.visible = false;
    },
  },
};
</script>

<style lang="less" scoped>
.wl-notice {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 2000;
  .bg {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.45);
  }
  .notice {
    position: absolute;
    border-radius: 10px;
    top: 18%;
    left: 50%;
    transform: translateX(-50%);
    background-color: #fff;
    width: 640px;
    max-width: calc(100vw - 32px);
    max-height: 78vh;
    display: flex;
    flex-direction: column;
    padding: 28px 32px 24px;
    box-sizing: border-box;
    box-shadow: 0 12px 40px rgba(1, 104, 236, 0.15);
    .title {
      text-align: center;
      font-size: 22px;
      font-weight: bold;
      color: #333;
      margin-bottom: 16px;
    }
    .content {
      flex: 1;
      overflow-y: auto;
      line-height: 1.7;
      font-size: 15px;
      color: #666;
      word-break: break-word;
      text-align: left;
      /deep/ h4 {
        margin: 16px 0 8px;
        font-size: 15px;
        font-weight: bold;
        color: #333;
        line-height: 1.5;
      }
      /deep/ p {
        margin: 0 0 10px;
      }
      /deep/ ul {
        margin: 0 0 12px;
        padding-left: 22px;
      }
      /deep/ li {
        margin: 4px 0;
      }
      /deep/ .notice-sign {
        margin-top: 16px;
        color: #999;
        text-align: right;
      }
      /deep/ .notice-closing {
        margin-top: 20px;
        padding: 14px 16px;
        font-size: 17px;
        font-weight: bold;
        line-height: 1.65;
        text-align: left;
        color: #0168ec;
        background: linear-gradient(
          90deg,
          rgba(1, 94, 234, 0.1),
          rgba(0, 192, 250, 0.12)
        );
        border-radius: 8px;
        border-left: 4px solid #10c1fc;
        box-shadow: 0 2px 12px rgba(1, 104, 236, 0.12);
      }
      /deep/ .notice-final {
        margin-top: 12px;
      }
    }
    .but {
      margin-top: 8px;
      height: 48px;
      line-height: 48px;
      text-align: center;
      color: #fff;
      font-size: 16px;
      border-radius: 24px;
      background: linear-gradient(-90deg, #10c1fc, #3f65f9);
      cursor: pointer;
      user-select: none;
    }
    &.mobile {
      top: 12%;
      width: calc(100vw - (40 / 3.75vw));
      padding: (20 / 3.75vw) (24 / 3.75vw) (16 / 3.75vw);
      .title {
        font-size: (18 / 3.75vw);
      }
      .content {
        font-size: (14 / 3.75vw);
        /deep/ .notice-closing {
          font-size: (15 / 3.75vw);
          padding: (12 / 3.75vw) (14 / 3.75vw);
        }
      }
      .but {
        height: (40 / 3.75vw);
        line-height: (40 / 3.75vw);
        font-size: (14 / 3.75vw);
      }
    }
  }
}
.bounce-enter-active {
  animation: bounce-in 0.3s;
}
.bounce-leave-active {
  animation: bounce-in 0.3s reverse;
}
@keyframes bounce-in {
  0% {
    transform: translateY(-20%);
    opacity: 0;
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
